const Panel = ({ children, borderColor = "border-gray-300" }) => {
  return (
    <div className={`border ${borderColor} rounded-3xl p-5 bg-white mb-2`}>{children}</div>
  );
};

export default Panel;
